module.exports = __webpack_public_path__ + "assets/img/media_5.7f2a8c77.png";